const DB_NAME = "fillapp-pdf-editor";

export const TABS_STORE = "tabs";
export const DOCUMENTS_STORE = "documents";
export const CONVERSATIONS_STORE = "conversations";
export const CHECKPOINTS_STORE = "checkpoints";

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (typeof indexedDB === "undefined") {
    return Promise.reject(new Error("IndexedDB unavailable"));
  }
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      db.createObjectStore(TABS_STORE, { keyPath: "id" });
      db.createObjectStore(DOCUMENTS_STORE, { keyPath: "id" });
      db.createObjectStore(CONVERSATIONS_STORE, { keyPath: "id" });
      const checkpoints = db.createObjectStore(CHECKPOINTS_STORE, {
        keyPath: "id",
      });
      checkpoints.createIndex("by_tab_chat", ["tabId", "chatId"], {
        unique: false,
      });
      checkpoints.createIndex("by_tab", "tabId", { unique: false });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export function getDb(): Promise<IDBDatabase> {
  if (!dbPromise) dbPromise = openDb();
  return dbPromise;
}

export function promisifyRequest<T>(req: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export function promisifyTxn(txn: IDBTransaction): Promise<void> {
  return new Promise((resolve, reject) => {
    txn.oncomplete = () => resolve();
    txn.onabort = () => reject(txn.error ?? new Error("Transaction aborted"));
    txn.onerror = () => reject(txn.error);
  });
}
